/* eslint-disable no-unused-vars */
import React from 'react';
import style from './main.module.scss';
import MainSearch from 'components/mainSearch/mainSearch';
import { selectImagesLimit, selectResourceByName } from 'store/page/pageSlice';
import { useContentAdapter } from 'hooks/useContentAdapter';
import includes from 'lodash-es/includes';
import { getTotal } from 'utils/utils';
import Pagination from 'components/pagination/pagination';
import { PossibleAction, resourceSortTypes } from 'store/types';
import { useAppSelector } from 'store/hooks';
import Sorting from 'components/sorting/sorting';
import { useMatch } from 'react-router-dom';
import { getCommonOmitActions } from 'utils/hooked';
import Grid2 from 'components/grid/grid2';
import isEmpty from 'lodash-es/isEmpty';
import { useResourceReRequest } from 'hooks/useResourceReRequest';
import cx from 'classnames';

export default function Main() {
  const mainChecker = useMatch('/:name/*')?.params.name;
  const selector = selectResourceByName.bind(null, 'search');
  const resource = useAppSelector(selector);
  const imagesLimit = useAppSelector(selectImagesLimit);

  const omitedCommon = getCommonOmitActions();

  const content = useContentAdapter(resource?.data || {}, {
    actions: (['edit', 'download', 'delete'] as PossibleAction[]).filter(
      (action: PossibleAction) => !includes(omitedCommon, action)
    ),
  });
  useResourceReRequest(resource);

  return (
    <>
      <MainSearch text="Поиск лучших изображений на тему транспорта"></MainSearch>

      {resource === undefined || !isEmpty(resource?.data) ? (
        <>
          <Sorting
            items={resourceSortTypes}
            defaultSelectedValue={resourceSortTypes[6]}
            startURL={`/${mainChecker || 'photos'}?`}
          ></Sorting>
          <div className={cx(style.grid, 'adaptive-main__grid')}>
            <Grid2 images={content}></Grid2>
          </div>
        </>
      ) : (
        <span
          className={
            'notFoundtext roundPadding notFoundBlock adaptive-main__notFoundText'
          }
        >
          Извините, ничего не найдено
        </span>
      )}
      <Pagination
        className={'adaptive-main__pagination'}
        total={getTotal(resource, imagesLimit)}
      ></Pagination>
    </>
  );
}
